var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("span", { staticClass: "picNum" }, [
        _vm._v("共" + _vm._s(_vm.pictures.length) + "张"),
      ]),
      _vm.brandName
        ? _c("span", { staticClass: "brand" }, [_vm._v(_vm._s(_vm.brandName))])
        : _vm._e(),
      _c("img", {
        class: _vm.firstSheet ? "imgPic" : "",
        style: { height: _vm.height + "px", width: _vm.width + "px" },
        attrs: { src: _vm.firstSheet ? _vm.firstSheet : _vm.noImage, alt: "" },
      }),
      _c("showPicture", { ref: "showPicture" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }